import { NavLink } from "react-router";
import ReglementsList from "../../components/Reglements/ReglementsList";
import { useTrads } from "../../contexts/trads/useTrads";

function Reglements(){
  const {translate}=useTrads();
  return (
  <div>
    <nav>
        <NavLink to={`/reglements/add`} className="btn btn-primary mt-3">{translate('btn_add')}</NavLink>
    </nav>
    <ReglementsList   />
  </div>
  );
}
export default Reglements;